import React from "react";
import { useDispatch } from "react-redux";
import { setLoading, getStageScreen } from "../../../../redux";
import Title from "../../components/Title";
import Button from "../../components/Button";

const BrokerPayment = () => {
  const dispatch = useDispatch();
  const handleSubmit = () => {
    dispatch(setLoading(true));
    setTimeout(() => {
      dispatch(setLoading(false));
      dispatch(getStageScreen());
    }, 2000);
  };
  return (
    <React.Fragment>
      <Title title="Broker Payment" />
      <div className="col-md-12 mt-3">
        <Button type="button" title="Submit" handleClick={handleSubmit} />
      </div>
    </React.Fragment>
  );
};

export default BrokerPayment;
